<template>
  <div class="flex flex-col items-center gap-4 text-12 border th-border">
    <WFTranslate k="offer-qr"></WFTranslate>
    <img :src="qr" class="w-80"/>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
    props: {
        offer: {
            default: null,
            type: Object
        }
    },
    data() {
        return {
            qr: null,
        };
    },
    watch: {
        offer() {
            this.genQR(this.offer);
        },
    },
    mounted() {
        this.genQR(this.offer);
    },
    methods: {
        genQR (_offer) {
            if(_offer) {
                let slug = this.$wayfinder.settings.get("template.project.slug", "lounakeskus")
                let url = "https://astri.ee/" + slug + "/" + _offer.slug;
            
                QRCode.toDataURL(url).then((val) => {
                    this.qr = val;
                })
            }
        }
    },
};
</script>